module.exports = __webpack_public_path__ + "img/zhengshu6.46dc907d.jpg";